import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/servicios/servicios-de-regulatory-affairs-para-pharma-biotech")({
  head: () => buildRouteHead("/es/servicios/servicios-de-regulatory-affairs-para-pharma-biotech", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/servicios/regulatory-affairs", replace: true });
  },
});
